import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, } from 'reactstrap';
import Loader from 'components/Loader';
import {getNudgeEmailPreview} from 'utils/api';
import './style.scss';

const PreviewNudgeEmailModal = ({isOpen, toggle, item}) => {
    const [loading, setLoading] = useState(true);
    const [emailUnavailable, setEmailUnavailable] = useState(false);
    const [emailContent, setEmailContent] = useState(null);

    useEffect(() => {
        item && fetchEmailPreview();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchEmailPreview = async() => {
        try {
            let emailData = await getNudgeEmailPreview(item.id);
            setEmailContent(emailData.content);
            setLoading(false);
        } catch(err) {
            console.log(err);
            setLoading(false);
            setEmailUnavailable(true)
        }

    }

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <div className="preview-modal-header">
                    <h3>Nudge Email Preview:</h3>
                    {item.name && <h5 className="mt-1"><span style={{fontWeight: 600}}>Entity name:</span> {item.name}</h5>}
                    {emailContent && <h5><span style={{fontWeight: 600}}>Subject:</span> {emailContent.title}</h5>}
                </div>
            </ModalHeader>
            <ModalBody style={{minHeight: '500px'}}>
                {loading ?
                    <Loader small text="Fetching email content"/>
                    :
                    emailUnavailable ?
                        <div style={{'fontWeight': 700}}>
                            This email is not available yet. Please check again later for updated content.</div>
                        :
                        emailContent.html ?
                        <div
                            className="email-preview-inner"
                            dangerouslySetInnerHTML={{__html: emailContent.html}}
                        />
                        : <div style={{'fontWeight': 700}}>
                                This email is not available yet. Please check again later for updated content.</div>
                }
            </ModalBody>
        </Modal>
    );
};

export default PreviewNudgeEmailModal;
